import React, { useEffect } from "react";
import { SubmitHandler, UseFormReturn, useForm } from "react-hook-form";

type HookFormProps = {
  onSubmit?: SubmitHandler<any>;
  init?: (method: UseFormReturn<any>) => void;
  defaultForm?: any;
  children: (method: UseFormReturn<any>) => React.ReactNode;
};

function HookForm({
  onSubmit = () => {},
  init,
  defaultForm = {},
  children,
}: HookFormProps) {
  const method = useForm({
    mode: "onChange",
    defaultValues: defaultForm,
    criteriaMode: "all",
  });

  useEffect(() => {
    if (init) {
      init(method);
    }
  }, [init, method]);

  return (
    <form onSubmit={method.handleSubmit(onSubmit)}>
      {children(method)}
    </form>
  );
}

export default HookForm;
